import React from 'react';
import { Link } from 'react-router-dom';
import Contact from './Contact';

const Home = () => {
  // Featured journal
  const featuredJournals = [
    {
      id: 1,
      title: 'Journal of Asia Entrepreneurship and Sustainability',
      abbreviation: 'JAES',
      description: 'A leading peer-reviewed journal focusing on entrepreneurship and sustainable development in the Asian context. We publish high-quality research that explores innovative business models, policy frameworks, and entrepreneurial ecosystems.',
      submissionLink: '/submit-paper?journal=jaes',
      journalLink: 'https://asiaentrepreneurshipjournal.com/index.php/jaes/index'
    }
  ];

  return (
    <div>
      {/* Hero Section */}
      <section id="hero" className="hero position-relative overflow-hidden">
        <div className="position-absolute top-0 start-0 w-100 h-100" style={{
          background: 'linear-gradient(135deg, rgba(42, 74, 127, 0.4) 0%, rgba(33, 58, 99, 0.8) 100%)',
          zIndex: 0
        }}></div>
        <div className="container position-relative" style={{ zIndex: 1 }}>
          <div className="row min-vh-75 align-items-center">
            <div className="col-lg-8 mx-auto text-center py-0 py-lg-5">
              <div className="mb-4">
                <h1 className="display-3 fw-bold text-white mb-3 animate__animated animate__fadeInDown">Asia Academic Press</h1>
                <div className="divider mx-auto bg-white mb-4" style={{
                  height: '4px',
                  width: '100px',
                  opacity: 0.8,
                  animation: 'expandWidth 1.5s ease-out forwards'
                }}></div>
              </div>
              <h2 className="h1 fw-light text-white mb-4 animate__animated animate__fadeInUp" style={{
                textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                lineHeight: '1.3'
              }}>Empowering Asian Researchers Through Peer-Reviewed Publishing</h2>
              <p className="lead text-white-75 mb-2 animate__animated animate__fadeInUp" style={{
                fontSize: '1.25rem',
                maxWidth: '700px',
                margin: '0 auto 2rem',
                textShadow: '0 1px 2px rgba(0,0,0,0.2)'
              }}>Enabling academic excellence through accessible and credible research dissemination across Asia and beyond.</p>
              <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 animate__animated animate__fadeInUp">
                <Link
                  to="/submit-paper"
                  className="btn btn-primary btn-lg px-4 py-3 fw-semibold"
                  style={{
                    minWidth: '200px',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
                  }}
                >
                  Submit Your Paper
                </Link>
                <Link
                  to="/author-guidelines"
                  className="btn btn-outline-light btn-lg px-4 py-3 fw-semibold"
                  style={{
                    minWidth: '200px',
                    transition: 'all 0.3s ease',
                    borderWidth: '2px'
                  }}
                >
                  Author Guidelines
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Journals */}
      <section id="journals" className="py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title">Our Journal</h2>
            <p className="lead">A premier publication for research on entrepreneurship and sustainable development in Asia</p>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="card h-100">
                <div className="card-body">
                  <div className="d-flex flex-column flex-md-row align-items-center">
                    <div className="me-md-4 mb-4 mb-md-0">
                      <img
                        src="/jaes-logo.png"
                        alt="JAES Logo"
                        className="img-fluid"
                        style={{ maxWidth: '200px' }}
                      />
                    </div>
                    <div className="text-center text-md-start">
                      <h3 className="card-title">{featuredJournals[0].title}</h3>
                      <h5 className="text-muted mb-4">{featuredJournals[0].abbreviation}</h5>
                      <p className="card-text">{featuredJournals[0].description}</p>

                      <div className="mt-4 d-flex flex-column flex-md-row align-items-center align-items-md-start gap-3">
                        <span className="badge bg-light text-dark p-2">
                          {featuredJournals[0].category}
                        </span>
                        <div className="d-flex flex-column flex-md-row gap-3 w-100 justify-content-center justify-content-md-start">
                          <Link
                            to={featuredJournals[0].submissionLink}
                            className="btn btn-primary"
                          >
                            Submit Paper
                          </Link>
                          <a
                            href={featuredJournals[0].journalLink}
                            className="btn btn-outline-primary"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            View Journal
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About-Us */}
      <section id="about" className="about-page py-2 bg-white">
        <div className="container">
          {/* Page Header */}
          <div className="text-center mb-2 pb-3">
            <h2 className="section-title">About Asia Academic Press</h2>
            <div className="mx-auto" style={{ maxWidth: '700px' }}>
              <p className="lead text-muted">Dedicated to supporting scholars through peer-reviewed publications, editorial integrity, and academic collaboration across the Asia region and beyond.</p>
            </div>
          </div>

          {/* Mission & Vision */}
          <div className="row align-items-center justify-content-between mb-5 py-4 py-md-5 px-3 px-md-0">
            <div className="col-lg-6 mb-2 mb-lg-0">
              <div className="pe-lg-5 ps-0 ps-md-3 ps-lg-0">
                <span className="badge bg-primary bg-opacity-10 text-primary mb-3">Our Mission</span>
                <h2 className="mb-4">Advancing Scholarly Excellence in the Asia</h2>
                <div className="mb-4">
                  <p>Asia Academic Press is dedicated to the advancement of scholarly research and knowledge dissemination across various academic disciplines. We provide a dynamic platform for researchers, academics, and professionals to share their findings and contribute to the global academic community.</p>
                  <p className="mb-0">Our mission is to promote high-quality research that addresses both regional and global challenges, with a particular focus on the Asia context, while maintaining the highest standards of academic integrity.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="position-relative">
                <div className="rounded-4 overflow-hidden shadow-lg">
                  <img
                    src="https://images.pexels.com/photos/6147381/pexels-photo-6147381.jpeg"
                    alt="Our Mission"
                    className="img-fluid w-100 h-auto"
                    style={{ objectFit: 'cover', minHeight: '300px', maxHeight: '500px' }}
                  />
                </div>
                <div className="position-absolute bottom-0 start-0 bg-primary text-white p-3 m-4 rounded-3" style={{ maxWidth: '300px' }}>
                  <h5 className="mb-1">Global Reach</h5>
                  <p className="small mb-0">Connecting researchers across 50+ countries</p>
                </div>
              </div>
            </div>
          </div>

          <div className="row align-items-center justify-content-between py-4 py-md-5 my-4 my-md-5 bg-light rounded-4 mx-0 mx-md-3">
            <div className="col-lg-5 order-lg-2 mb-lg-0">
              <div className="ps-lg-5 pe-0 pe-md-3 pe-lg-5">
                <span className="badge bg-primary bg-opacity-10 text-primary mb-3">Our Vision</span>
                <h2 className="mb-4">Shaping the Future of Academic Publishing</h2>
                <div className="mb-4">
                  <p>We envision becoming the leading academic press in the Asia region, recognized for our commitment to academic excellence, innovation, and the dissemination of impactful research that contributes to societal development and global knowledge.</p>
                  <p className="mb-0">By fostering collaboration among researchers and institutions, we aim to create a vibrant academic community that addresses the most pressing challenges of our time through interdisciplinary research and innovative solutions.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 order-lg-1 ps-0 ps-md-3 ps-lg-0">
              <div className="position-relative">
                <div className="rounded-4 overflow-hidden shadow-lg">
                  <img
                    src="https://images.pexels.com/photos/5386754/pexels-photo-5386754.jpeg"
                    alt="Our Vision"
                    className="img-fluid w-100 h-auto"
                    style={{ objectFit: 'cover', minHeight: '300px', maxHeight: '500px' }}
                  />
                </div>
                <div className="position-absolute bottom-0 end-0 bg-white text-dark p-3 m-4 rounded-3 shadow-sm" style={{ maxWidth: '300px' }}>
                  <h5 className="mb-1">Innovation</h5>
                  <p className="small mb-0">Pioneering new approaches in academic publishing</p>
                </div>
              </div>
            </div>
          </div>

          {/* Values */}
          <section className="position-relative py-5 my-5 rounded-4 overflow-hidden" style={{
            background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)',
            border: '1px solid rgba(203, 213, 225, 0.3)'
          }}>
            <div className="position-absolute top-0 end-0 w-100 h-100" style={{
              backgroundImage: 'radial-gradient(rgba(42, 74, 127, 0.1) 1px, transparent 1px)',
              backgroundSize: '20px 20px',
              opacity: 0.6
            }}></div>
            <div className="container position-relative">
              <div className="text-center mb-5">
                <span className="badge bg-primary bg-opacity-10 text-primary mb-3">OUR VALUES</span>
                <h2 className="mb-3">Our Core Values</h2>
                <p className="lead text-muted">Guiding principles that define our work and commitment to excellence</p>
              </div>

              <div className="row g-4">
                <div className="col-md-4">
                  <div className="bg-white p-4 rounded-4 h-100 shadow-sm transition-all hover-shadow">
                    <div className="icon-box bg-primary bg-opacity-10 text-primary rounded-3 d-inline-flex align-items-center justify-content-center mb-4" style={{ width: '70px', height: '70px' }}>
                      <i className="fas fa-award fa-2x"></i>
                    </div>
                    <h4 className="mb-3">Excellence</h4>
                    <p className="text-muted mb-0">We are committed to maintaining the highest standards of academic rigor and publishing quality research that makes a significant contribution to knowledge across disciplines.</p>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="bg-white p-4 rounded-4 h-100 shadow-sm transition-all hover-shadow">
                    <div className="icon-box bg-primary bg-opacity-10 text-primary rounded-3 d-inline-flex align-items-center justify-content-center mb-4" style={{ width: '70px', height: '70px' }}>
                      <i className="fas fa-balance-scale fa-2x"></i>
                    </div>
                    <h4 className="mb-3">Integrity</h4>
                    <p className="text-muted mb-0">We uphold the highest ethical standards in publishing, ensuring transparency, fairness, and accountability in all our editorial and peer-review processes.</p>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="bg-white p-4 rounded-4 h-100 shadow-sm transition-all hover-shadow">
                    <div className="icon-box bg-primary bg-opacity-10 text-primary rounded-3 d-inline-flex align-items-center justify-content-center mb-4" style={{ width: '70px', height: '70px' }}>
                      <i className="fas fa-users fa-2x"></i>
                    </div>
                    <h4 className="mb-3">Collaboration</h4>
                    <p className="text-muted mb-0">We believe in the power of collaboration and actively foster partnerships between researchers, institutions, and practitioners to drive meaningful impact.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>


      {/* Research Paper Publication Procedure Section */}
      <section id="publication-procedure" className="py-4 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title">Research Paper Publication Procedure</h2>
            <p className="lead">Follow these simple steps to publish your research with us</p>
          </div>

          <div className="row text-center">
            <div className="col-md-3 mb-4">
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <i className="fas fa-upload fa-2x mb-3 text-primary"></i>
                  <h5 className="card-title">Step 1: Online Submission</h5>
                  <p className="card-text">Submit your manuscript through the journal's official submission portal.</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <i className="fas fa-search fa-2x mb-3 text-primary"></i>
                  <h5 className="card-title">Step 2: Peer Review</h5>
                  <p className="card-text">The manuscript undergoes a double-blind peer review to ensure quality and integrity.</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <i className="fas fa-credit-card fa-2x mb-3 text-primary"></i>
                  <h5 className="card-title">Step 3: Article Processing Charges (APC)</h5>
                  <p className="card-text">Upon acceptance, authors will be requested to pay the applicable APC through our secure payment system.</p>
                </div>
              </div>
            </div>
            <div className="col-md-3 mb-4">
              <div className="card h-100 shadow-sm">
                <div className="card-body">
                  <i className="fas fa-globe fa-2x mb-3 text-primary"></i>
                  <h5 className="card-title">Step 4: Online Publication</h5>
                  <p className="card-text">The final, peer-reviewed article will be published online and made accessible through the journal's platform and indexing databases.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



      {/* Benefits of Publishing with Asia Academic Press */}
      <section id="benefits" className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title">Benefits of Publishing with Asia Academic Press</h2>
            <p className="lead">Why researchers choose us for high-quality academic publishing</p>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="card shadow-sm border-0">
                <div className="card-body">
                  <div className="row g-4">
                    <div className="col-md-6">
                      <div className="mb-4">
                        <h4 className="h5 mb-2">Reputed Indexing & Recognition</h4>
                        <p className="mb-0 text-muted">
                          Our flagship journal, Journal of Asia Entrepreneurship and Sustainability, is indexed in the Australian Business Deans Council (ABDC) list, ensuring high visibility and academic credibility.
                        </p>
                      </div>

                      <div className="mb-4">
                        <h4 className="h5 mb-2">Global Reach & Readership</h4>
                        <p className="mb-0 text-muted">
                          Widely read by scholars, industry professionals, and policymakers across Asia-Pacific and beyond. Indexed in respected databases to ensure research reaches the right audience.
                        </p>
                      </div>

                      <div className="mb-4">
                        <h4 className="h5 mb-2">Rigorous Peer Review</h4>
                        <p className="mb-0 text-muted">
                          The double-blind peer review process ensures the highest academic quality and integrity.
                        </p>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="mb-4">
                        <h4 className="h5 mb-2">Experienced Editorial Board</h4>
                        <p className="mb-0 text-muted">
                          Led by international experts with extensive academic and industry experience. Our board provides unparalleled insights and strategic direction to maintain the journal's prestige.
                        </p>
                      </div>

                      <div className="mb-4">
                        <h4 className="h5 mb-2">Ethical Publishing Standards</h4>
                        <p className="mb-0 text-muted">
                          Adherence to COPE guidelines and global best practices for transparency and integrity. We are dedicated to upholding the highest standards to build trust and ensure the validity of research.
                        </p>
                      </div>

                      <div>
                        <h4 className="h5 mb-2">Structured Editorial Workflow</h4>
                        <p className="mb-0 text-muted">
                          Efficient editorial process ensuring timely and high-quality publication of accepted research. Our streamlined system provides a seamless experience for authors from submission to publication.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Licence & Indexing */}
      <section id="licence" className="py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title">Licence & Indexing</h2>
            <p className="lead">Our journals are licensed and indexed in globally recognized databases</p>
          </div>

          <div className="journal-indexing d-flex flex-wrap justify-content-center align-items-center">
            {/* Wrapper with padding and smaller image */}
            <div className="p-2 p-sm-3 text-center">
              <a href="https://abdc.edu.au/abdc-journal-quality-list/" target="_blank" rel="noopener noreferrer">
                <img
                  src="/abdc-logo.svg"
                  alt="ABDC"
                  title="ABDC"
                  height="20"
                  width="150"
                  className="img-fluid"
                />
              </a>
            </div>
            <div className="p-2 p-sm-3 text-center">
              <a href="https://www.doi.org/" target="_blank" rel="noopener noreferrer">
                <img
                  src="/doi-logo.svg"
                  alt="DOI"
                  title="Digital Object Identifier"
                  height="80"
                  width="100"
                  className="img-fluid"
                />
              </a>
            </div>
            <div className="p-2 p-sm-3 text-center">
              <a href="https://www.crossref.org/" target="_blank" rel="noopener noreferrer">
                <img
                  src="/crossref-logo.svg"
                  alt="Crossref"
                  title="Crossref"
                  height="20"
                  width="100"
                  className="img-fluid"
                />
              </a>
            </div>
            <div className="p-2 p-sm-3 text-center">
              <a href="https://publicationethics.org/" target="_blank" rel="noopener noreferrer">
                <img
                  src="/cope-logo.png"
                  alt="COPE"
                  title="Committee on Publication Ethics"
                  height="20"
                  width="100"
                  className="img-fluid"
                />
              </a>
            </div>
            <div className="p-2 p-sm-3 text-center">
              <a href="https://portal.issn.org/" target="_blank" rel="noopener noreferrer">
                <img
                  src="/issn-logo.png"
                  alt="ISSN"
                  title="International Standard Serial Number"
                  height="20"
                  width="170"
                  className="img-fluid"
                />
              </a>
            </div>
            <div className="p-2 p-sm-3 text-center">
              <a href="https://portal.issn.org/" target="_blank" rel="noopener noreferrer">
                <img
                  src="/doaj.svg"
                  alt="DOAJ"
                  title="International Standard Serial Number"
                  height="20"
                  width="170"
                  className="img-fluid"
                />
              </a>
            </div>
          </div>

        </div>
      </section>



      <Contact />

      {/* FAQ Section */}
      <section className="py-5 bg-light">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title">Frequently Asked Questions</h2>
            <p className="lead">Find answers to common questions about our publication process</p>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="accordion" id="faqAccordion">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                      How can I submit a paper to your journal?
                    </button>
                  </h2>
                  <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#faqAccordion">
                    <div className="accordion-body">
                      You can submit your paper by visiting the journal's page and clicking on the "Submit Paper" button. You'll be directed to our online submission system, where you can upload your manuscript, following the provided submission guidelines.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                      What is the peer review process like?
                    </button>
                  </h2>
                  <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#faqAccordion">
                    <div className="accordion-body">
                      Our peer review process typically takes 4-6 weeks. Each submission is reviewed by at least two independent experts in the field. The process is double-blind, meaning both the reviewers and authors remain anonymous to each other.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                      Do you charge any publication fees?
                    </button>
                  </h2>
                  <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#faqAccordion">
                    <div className="accordion-body">
                      Yes there is a publication fee for this journal. The Article Processing Charge (APC) is specified on the journal's page. Please refer to the journal's guidelines for detailed information about the fee.
                    </div>
                  </div>
                </div>
              </div>

              <div className="text-center mt-5">
                <p className="mb-0">
                  Can't find what you're looking for?{' '}
                  <a
                    href="#contact"
                    className="text-primary"
                    onClick={(e) => {
                      e.preventDefault();
                      const contactSection = document.getElementById('contact');
                      if (contactSection) {
                        const headerOffset = 80; // Adjust this value based on your header height
                        const elementPosition = contactSection.getBoundingClientRect().top;
                        const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
                        window.scrollTo({
                          top: offsetPosition,
                          behavior: 'smooth'
                        });
                      }
                    }}
                  >
                    Contact us
                  </a>{' '}
                  and we'll be happy to help!
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="py-5" style={{
        background: 'linear-gradient(135deg, #2a4a7f 0%, #1a365d 100%)',
        position: 'relative',
        overflow: 'hidden',
        color: '#ffffff'
      }}>
        <div className="position-absolute top-0 end-0 w-100 h-100" style={{
          backgroundImage: 'radial-gradient(rgba(255, 255, 255, 0.1) 1px, transparent 1px)',
          backgroundSize: '30px 30px',
          opacity: 0.6,
          pointerEvents: 'none',
          zIndex: 0
        }}></div>
        <div className="position-relative" style={{ zIndex: 1 }}>
          <div className="container text-center">
            <h2 className="mb-4" style={{ color: '#ffffff', textShadow: '0 2px 4px rgba(0,0,0,0.2)' }}>Ready to Publish Your Research?</h2>
            <p className="lead mb-4" style={{ color: 'rgba(255,255,255,0.9)', maxWidth: '700px', margin: '0 auto' }}>Join our community of researchers and contribute to the advancement of knowledge in your field.</p>
            <div className="d-flex justify-content-center gap-3">
              <Link to="/submit-paper" className="btn btn-light btn-lg">Submit Your Paper</Link>
              <Link to="/author-guidelines" className="btn btn-outline-light btn-lg">Author Guidelines</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
